import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const Post = (props) => {

  let post = props.post
  let title = post.title
  let link = post.link
  let companies = post.companies.join(' / ')
  let locations = post.locations.join(' / ')
  let times = post.times.join(' / ')

  return (
    <a href={link} className="c-vacancy u-flex u-flex-sb u-flex-v-center">
      <h3 className="c-vacancy__title" dangerouslySetInnerHTML={{ __html: title }} />

      <div class="c-vacancy__terms">  
        <div className="c-vacancy__term c-vacancy__times" dangerouslySetInnerHTML={{ __html: times }} />
        <div className="c-vacancy__term c-vacancy__locations" dangerouslySetInnerHTML={{ __html: locations }} />
        <div className="c-vacancy__term c-vacancy__companies" dangerouslySetInnerHTML={{ __html: companies }} />
      </div>
    </a>
  )
}

export default Post



// WEBPACK FOOTER //
// ./src/js/vacancies/components/Post.js